import axios from 'axios'

import { addAuthTokenToRequest } from './utils/addAuthTokenToRequest'

const api = axios.create({
  baseURL: process.env.VUE_APP_HOST_BACKEND,
})

api.interceptors.request.use(addAuthTokenToRequest)

export async function uploadFile(file, options = {}) {
  const {
    data: { publicURL, uploadURL, key },
  } = await api.post('uploads/signed-url', {
    contentType: file.type,
    fileName: file.name,
    ...options,
  })

  await axios.put(uploadURL, file, {
    headers: { 'Content-Type': file.type },
  })

  return { url: publicURL, key }
}

export default api
